<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-discounts-reporte-detalle'].refresh()"
    >
      <template #buttons>
        <b-button
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-discounts-reporte-detalle"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="60vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="fraction_id"
          :empty-text="$t('No matching records found')"
          foot-clone
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(empleado)="data">
            <router-link
              target="_blank"
              class="text-primary"
              :to="{
                name: 'rrhh-employees-information',
                params: { id: data.item.employee_id },
              }"
            >
              <feather-icon
                v-if="data.item.tipo_personal == 'Driver'"
                icon="TruckIcon"
                size="16"
                class="text-warning"
              />
              <feather-icon
                v-else
                icon="UserIcon"
                size="16"
                class="text-success"
              />
              {{ data.item.empleado | capitalize }} </router-link
            ><br />
            <span style="opacity: 0.7"> {{ data.item.area | capitalize }} </span
            ><br />
            <span style="opacity: 0.7" class="text-primary">
              {{ data.item.numero_documento | capitalize }}
            </span>
          </template>

          <template #cell(monto)="data">
            <span class="text-success font-weight-bold">
              S/ {{ data.item.monto | currency }}
            </span>
          </template>

          <template #cell(estado_cuota)="data">
            <b-badge
              :variant="data.item.estado_cuota === 'Discounted' ? 'light-success' : 'light-warning'"
            >
              {{ data.item.estado_cuota === 'Discounted' ? 'Descontado' : 'Pendiente' }}
            </b-badge>
          </template>
          
          <template #cell(fecha_cuota)="data">
            {{ data.item.fecha_cuota | myGlobalDay }}
          </template>

          <!-- FOOTER -->
          <template #foot(empleado)>
            <div>
              <span class="font-weight-bold">SUBTOTAL (Página)</span><br/>
              <span class="font-weight-bold">TOTAL (General)</span>
            </div>
          </template>
          <template #foot(tipo_descuento)><span></span></template>
          <template #foot(fecha_cuota)><span></span></template>
          <template #foot(monto)>
            <div class="text-right">
              <span class="font-weight-bold text-primary">S/ {{ subtotalPagina | currency }}</span><br/>
              <span class="font-weight-bold text-success">S/ {{ totalGeneral | currency }}</span>
            </div>
          </template>
          <template #foot(estado_cuota)><span></span></template>
          <template #foot(observacion)><span></span></template>

        </b-table>
      </template>
    </filter-slot>

  </div>
</template>

<script>
/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* Services */
import DiscountService from "@/views/commons/discounts/services/discounts.service.js";
import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
  },
  data() {
    return {
      filters: [
        {
          type: "b-form-datepicker",
          margin: true,
          showLabel: true,
          label: "Desde",
          placeholder: "Date",
          class: "font-small-2",
          model: null,
          locale: "es",
          dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
          cols: 6,
        },
        {
          type: "b-form-datepicker",
          margin: true,
          showLabel: true,
          label: "Hasta",
          placeholder: "Date",
          class: "font-small-2",
          model: null,
          locale: "es",
          dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
          cols: 6,
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Tipo Descuento",
          labelName: "name",
          options: [],
          model: null,
          cols: 12,
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Estado de la Cuota",
          labelName: "label",
          options: [
            { label: 'Todos', value: null },
            { label: 'Descontado', value: 'Discounted' },
            { label: 'Pendiente', value: 'Not Discounted' }
          ],
          model: null,
          cols: 12,
          reduce: "value"
        },
        {
          type: "v-select",
          margin: true,
          showLabel: true,
          label: "Tipo Persona",
          labelName: "label",
          options: [
            { label: 'Todos', value: null },
            { label: 'Conductor', value: 'Driver' },
            { label: 'Administrativo', value: 'Employee' }
          ],
          model: null,
          cols: 12,
          reduce: "value"
        },
      ],
      fields: [
        { key: "empleado", label: "Trabajador" },
        { key: "tipo_descuento", label: "Tipo de Descuento" },
        { key: "fecha_cuota", label: "Fecha Cuota", class: "text-center" },
        { key: "monto", label: "Monto", class: "text-right" },
        { key: "estado_cuota", label: "Estado", class: "text-center" },
        { key: "observacion", label: "Observación" },
      ],
      items: [],
      totalGeneral: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Buscar por empleado o DNI...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
    };
  },
  async created() {
    await this.getDiscountTypes();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    subtotalPagina() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.monto) || 0),
        0
      );
    },
  },
  methods: {
    async getDiscountTypes() {
      try {
        const { data } = await DiscountService.getDiscountTypes();
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();

        const params = {
          search_txt: this.filterPrincipal.model,
          page: ctx.currentPage,
          perpage: ctx.perPage,
          start_date: this.filters[0].model,
          end_date: this.filters[1].model,
          discount_type_id: this.filters[2].model,
          status: this.filters[3].model,
          personal_type: this.filters[4].model,
        };

        const { data } = await DiscountService.getDescuentosReporteDetalle(params);

        const paginador = data.paginator;
        this.totalGeneral = Number(data.total_monto) || 0;

        this.paginate.from = paginador.from;
        this.paginate.to = paginador.to;
        this.paginate.of = paginador.total;
        this.paginate.perPage = paginador.per_page;
        this.paginate.currentPage = paginador.current_page;

        this.items = paginador.data || [];
        return this.items;
      } catch (error) {
        console.error(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async exportToExcel() {
      try {
        this.addPreloader();

        const params = {
          search_txt: this.filterPrincipal.model,
          start_date: this.filters[0].model,
          end_date: this.filters[1].model,
          discount_type_id: this.filters[2].model,
          status: this.filters[3].model,
          personal_type: this.filters[4].model,
        };
        
        const response = await DiscountService.exportToExcelReporteDetalle(params);

        let filename = "DESCUENTOS_REPORTE_DETALLE.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-table-discounts-reporte-detalle"].refresh();
    },
  },
};
</script>

<style>
</style>
